import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { setPaginationParams } from "@osmonauts/helpers";
export class LCDQueryClient {
  constructor({
    requestClient
  }) {
    _defineProperty(this, "req", void 0);
    this.req = requestClient;
    this.params = this.params.bind(this);
    this.userRedemptionRecord = this.userRedemptionRecord.bind(this);
    this.userRedemptionRecordAll = this.userRedemptionRecordAll.bind(this);
    this.userRedemptionRecordForUser = this.userRedemptionRecordForUser.bind(this);
    this.epochUnbondingRecord = this.epochUnbondingRecord.bind(this);
    this.epochUnbondingRecordAll = this.epochUnbondingRecordAll.bind(this);
    this.depositRecord = this.depositRecord.bind(this);
    this.depositRecordAll = this.depositRecordAll.bind(this);
  }
  /* Parameters queries the parameters of the module. */

  async params(_params = {}) {
    const endpoint = `StrideLabs/stride/records/params`;
    return await this.req.get(endpoint);
  }
  /* Queries a UserRedemptionRecord by id. */

  async userRedemptionRecord(params) {
    const endpoint = `Stride-Labs/stride/records/user_redemption_record/${params.id}`;
    return await this.req.get(endpoint);
  }
  /* Queries a list of UserRedemptionRecord items. */

  async userRedemptionRecordAll(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      setPaginationParams(options, params.pagination);
    }
    const endpoint = `Stride-Labs/stride/records/user_redemption_record`;
    return await this.req.get(endpoint, options);
  }
  /* Queries a list of UserRedemptionRecord items by chainId / userId pair. */

  async userRedemptionRecordForUser(params) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      setPaginationParams(options, params.pagination);
    }
    const endpoint = `Stride-Labs/stride/records/user_redemption_record_for_user/${params.chainId}/${params.day}/${params.address}/${params.limit}`;
    return await this.req.get(endpoint, options);
  }
  /* Queries a EpochUnbondingRecord by id. */

  async epochUnbondingRecord(params) {
    const endpoint = `Stride-Labs/stride/records/epoch_unbonding_record/${params.epochNumber}`;
    return await this.req.get(endpoint);
  }
  /* Queries a list of EpochUnbondingRecord items. */

  async epochUnbondingRecordAll(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      setPaginationParams(options, params.pagination);
    }
    const endpoint = `Stride-Labs/stride/records/epoch_unbonding_record`;
    return await this.req.get(endpoint, options);
  }
  /* Queries a DepositRecord by id. */

  async depositRecord(params) {
    const endpoint = `Stride-Labs/stride/records/deposit_record/${params.id}`;
    return await this.req.get(endpoint);
  }
  /* Queries a list of DepositRecord items. */

  async depositRecordAll(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      setPaginationParams(options, params.pagination);
    }
    const endpoint = `Stride-Labs/stride/records/deposit_record`;
    return await this.req.get(endpoint, options);
  }
}